<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :selection="selection" @handleSelectionChange="handleSelectionChange" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.yearAndWeek')" prop="year">
            <el-date-picker id="getWeekDate" v-model="weekDataNow" :picker-options="{ firstDayOfWeek: 1 }" style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.yearAndWeeks')" @change="handleQuery">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="tabValue=='NORMAL'">
          <el-form-item :label="$t('SalesOrderToBeApproved.form.Approval')" prop="categoryCode">
            <BjSelectLov v-model="tabValue2" :option-list="TAB_LIST2" :placeholder="$t('chooseText')" :clearable="false" @change="changeCategoryCode"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.creditNote')" prop="isSeparatedCreditNote">
            <BjSelectLov v-model="queryParams.isSeparatedCreditNote" :option-list="STATUS_YES_TRUE" :placeholder="$t('chooseText')" :clearable="false" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.companySeller')" prop="clientCode">
            <BjSelectLov v-model="queryParams.clientCode" :option-list="clientCodeList" :placeholder="$t('chooseText')" @change="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="dialogVisible=true">{{ $t('addText') }}</el-button>
          <BjFrontendExport
            type="primary"
            class="main-btn"
            :label-list="labelList"
            :rows="selectedRows"
            file-name="Credit.csv"
          />
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="col.prop == 'transNo'">
                <span style="color: #3173d0;">{{ scope.row.transNo }}</span>
                <BjCopyIcon :copy="scope.row.transNo" />
              </template>
              <template v-else-if="col.prop == 'clientCode'">
                <span style="color: #3173d0;">{{ scope.row.clientCode }}</span>
                <BjCopyIcon :copy="scope.row.clientCode" />
              </template>
              <template v-else-if="col.prop == 'billCategory.name'">
                <span>{{ scope.row.billCategory.name }}</span>
              </template>
              <template v-else-if="col.prop == 'creditNoe'">
                <span>{{ scope.row.creditNoe ? 'Yes':'No' }}</span>
              </template>
              <template v-else-if="col.prop == 'weekyear'">
                {{ scope.row.year }} / {{ scope.row.week }}
              </template>
              <template v-else-if="col.prop == 'gmtCreate'">
                {{ scope.row.gmtCreate | timeFilters(scope.row.gmtCreate) }}
              </template>
              <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <template>
                <el-button type="text" class="edit-btn" @click="onDetail(props.row)">{{ $t('viewText') }}</el-button>
                <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-permission:BillingCreditAuditIsPass command="1" v-if="tabValue2 == 2">{{ $t('auditPassText')}}</el-dropdown-item>
                    <el-dropdown-item v-permission:BillingCreditAuditIsPass command="2" v-if="tabValue2 == 2">{{ $t('auditNotPassText')}}</el-dropdown-item>
                    <el-dropdown-item command="3">{{ $t('editText') }} </el-dropdown-item>
                    <el-dropdown-item command="4"> {{ $t('delText') }} </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <viewChargeDialog ref="chargeDialogRef" @reject="onReject" @edit="onEdit"/>

    <el-dialog :visible.sync="dialogVisible" width="960px">
      <credit-form ref="CreditFormRef" :category-code-list="categoryCodeList" :client-code-list="clientCodeList" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="onReset">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onSave('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { billApi } from '@/api';
import CreditForm from './components/CreditForm';
import viewChargeDialog from './components/viewChargeDialog';
import pageMiXin from '@/utils/page-mixin.js';
import { STATUS_YES_TRUE } from '@/utils/constants';

export default {
  name: 'BusinessBillingCredit',
  components: {
    CreditForm,
    viewChargeDialog
  },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 6,
      selection: true,
      STATUS_YES_TRUE,
      tableData: [],
      queryApi: billApi.getAdditionalChargeList,
      queryParams: {
        categoryCode: 'Credit',
        year: '', // year,
        clientCode: '',
        isSeparatedCreditNote: null,
      },
      // 下拉搜索列表
      clientCodeList: [],
      categoryCodeList: [],
      // tab页信息
      tabValue: 'NORMAL',
      TAB_LIST: [
        { label: this.$t('billingPage.normal'), value: 'NORMAL' },
        { label: this.$t('billingPage.once'), value: 'DISPO_FEE' },
      ],
      tabValue2: '1',
      TAB_LIST2: [
        { label: this.$t('ApprovedText2'), value: '1' },
        { label: this.$t('ApprovedPending'), value: '2' },
        { label: this.$t('ApprovedRejected'), value: '3' },
      ],
      labelList1: [
        // { label: this.$t('billingPage.transactionNumber'), prop: 'transNo', isCheck: true, disabled: false, width: 240 },
        { label: this.$t('billingPage.clientCode'), prop: 'clientCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.categoryName'), prop: 'billCategory.name', isCheck: true, disabled: false },
        { label: this.$t('billingPage.quantity'), prop: 'quantity', isCheck: true, disabled: false },
        { label: this.$t('billingPage.total'), prop: 'totalPrice', isCheck: true, disabled: false },
        { label: this.$t('billingPage.ApplyWeek'), prop: 'weekyear', isCheck: true, disabled: false, export: { formatter: (value, row) => `${row.year} / ${row.week}` } },
        { label: this.$t('billingPage.gmtCreate'), prop: 'gmtCreate', isCheck: true, disabled: false, export: { dateFormat: 'DD/MM/YYYY HH:mm' } },
        { label: this.$t('billingPage.creditNote'), prop: 'creditNoe', isCheck: true, disabled: false, export: { formatter: value => value ? 'Yes' : 'No' } },
        { label: this.$t('BjDialogListConfig.Operator'), prop: 'createdBy', isCheck: true, disabled: false },
        { label: this.$t('billingPage.description'), prop: 'description', isCheck: true, disabled: false },
        { label: this.$t('ApprovalDescription'), prop: 'auditDescription', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width:140 },
      ],
      weekDataNow: null, // new Date(),
      dialogVisible: false,
    };
  },
  computed: {
    labelList() {
      return this.tabValue2 == 3 ? this.labelList1 : this.labelList1.filter(item => item.prop != 'auditDescription')
    }
  },
  watch: {
    'weekDataNow'() {
      this.$nextTick(() => {
        this.queryParams.year = document.querySelector('#getWeekDate').value;
      });
    },
  },
  mounted() {
    this.getClientInfoList();
    this.getAllAdditionalCharges();
  },
  methods: {
    command(text, row) {
      switch (text) {
        case '1':
            this.onApprove(row)
            break;
        case '2':
            this.$refs.chargeDialogRef.dialogVisible2 = true;
            this.$refs.chargeDialogRef.form.transNo = row.transNo
            break;
        case '3':
            this.$refs.chargeDialogRef.dialogVisible3 = true;
            this.$refs.chargeDialogRef.form2.transNo = row.transNo
            break;
        case '4':
            this.onDel(row)
            break;
      }
    },
    onDetail(row){
      this.$refs.chargeDialogRef.dialogVisible = true;
      billApi.getTransactionDetail({transNo: row.transNo}).then(res=>{
        this.$refs.chargeDialogRef.tableData = [res.data]
      })
    },
    onApprove(item){
      billApi.approveAdditionalCharge({transNo: item.transNo}).then(()=>{
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      })
    },
    onReject(item){
      const { transNo, description } = item
      billApi.rejectAdditionalCharge({ transNo, description }).then(()=>{
        this.$refs.chargeDialogRef.close()
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      })
    },
    onEdit(item){
      const { transNo, quantity } = item
      billApi.updateAdditionalChargeDetail({ transNo, quantity }).then(()=>{
        this.$refs.chargeDialogRef.close()
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      })
    },
    changeCategoryCode(val){
      if(val == 1){
        this.queryApi = billApi.getAdditionalChargeList
      }else if(val == 2){
        this.queryApi = billApi.approvalPendingList
      }else{
        this.queryApi = billApi.approvalRejectedList
      }
      this.tabValue2 = val
      setTimeout(() => { this.reFresh(); }, 300);
    },
    // 获取所有客户信息列表
    getClientInfoList() {
      billApi.getClientInfoList().then(res => {
        res.data.forEach(item => {
          item.label = `${item.label} - ${item.value}`;
        });
        this.clientCodeList = res.data;
      });
    },
    // 获取所有增值服务收费项
    getAllAdditionalCharges() {
      billApi.getAllAdditionalCharges().then(res => {
        this.categoryCodeList = res.data;
      });
    },
    // 新增按钮
    onSave() {
      this.$refs.CreditFormRef.$refs.form.validate(valid => {
        if (valid) {
          const data = this.$refs.CreditFormRef.form;
          if (this.$refs.CreditFormRef.GSTType === "Incl") {
            if(!data.inclQuantity || data.inclQuantity == '0.00')return this.msgError(this.$t('inputText') +' ' + this.$t('billingPage.CreditGST'));
            if(data.inclQuantity=='NaN')return this.msgError(this.$t('billingPage.CreditGST') +' ' + this.$t('formatErrorText'));
            delete data.quantity;
          }else if(this.$refs.CreditFormRef.GSTType === "Excl"){
            if(!data.quantity || data.quantity == '0.00')return this.msgError(this.$t('inputText') +' ' + this.$t('billingPage.Credit'));
            if(data.quantity=='NaN')return this.msgError(this.$t('billingPage.Credit') +' ' + this.$t('formatErrorText'));
            delete data.inclQuantity;
          }
          billApi.addAdditionalChargeList(data).then(res => {
            if (res.code === 200) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.onReset();
            }else{
              this.onReset();
            }
          });
        }
      });
    },
    onReset() {
      this.dialogVisible = false
      this.$refs.CreditFormRef?.$refs['form'].resetFields();
      this.$refs.CreditFormRef?.init();
      this.reFresh();
    },
    // 删除按钮
    onDel(row) {
      billApi.delAdditionalChargeList({transNo: row.transNo}).then(res => {
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        setTimeout(() => { this.reFresh(); }, 300);
      });
    },
    beforeResetSearch() {
      this.weekDataNow = null;
      return new Promise(resolve => {
        resolve();
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}

.ts-divider {
  padding: 5px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
</style>
